// extracted by mini-css-extract-plugin
module.exports = {"base":"Checkbox_base__vfInO","error":"Checkbox_error__4chx_"};